import React from 'react'
import { observer } from 'mobx-react'
import { Collection, ForEachModel, SortBy, useModel } from '@morningtrain/react-resources'
import * as Filters from 'support/filters'
import { ScheduleTable } from 'ui/schedule'
import ScheduleDayOverviewColumn from 'widgets/shifts/themes/calendar/ScheduleDayOverviewColumn'
import * as Auth from '@morningtrain/react-auth'
import Permissions from 'services/Permissions'

function ScheduleSummaryOverview () {
  const scheduleModel = useModel()

  return (
    <Auth.Can permission={Permissions.SHIFTS_ADJUST_FORECAST}>
      <Collection resourceName='shifts.schedule' operationName='day_summary'>
        <Filters.ModelValueFilter name='schedule' modelKey='id' />
        <ScheduleTable>
          <SortBy by='date'>
            <ForEachModel>
              <ScheduleDayOverviewColumn scheduleModel={scheduleModel} />
            </ForEachModel>
          </SortBy>
        </ScheduleTable>
      </Collection>
    </Auth.Can>
  )
}

export default observer(ScheduleSummaryOverview)
